import { render, staticRenderFns } from "./OutbuildingView.vue?vue&type=template&id=245c922a"
import script from "./OutbuildingView.vue?vue&type=script&lang=ts"
export * from "./OutbuildingView.vue?vue&type=script&lang=ts"
import style0 from "./OutbuildingView.vue?vue&type=style&index=0&id=245c922a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports